import { render, staticRenderFns } from "./ProfileCompanyView.vue?vue&type=template&id=9d7722d2&"
import script from "./ProfileCompanyView.vue?vue&type=script&lang=js&"
export * from "./ProfileCompanyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports